import React, { FC, createRef, useEffect } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export interface InteractiveSessionsProps {

}

const videoUrl = require('../../../../Assets/screenFeatures/interactiveSessions/interactive-sessions.mp4');

const InteractiveSessions: FC<InteractiveSessionsProps> = (props) => {
    const classes = useStyles();

    const videoRef = createRef<HTMLVideoElement>();

    useEffect(() => {
        if (!videoRef.current) return;
        videoRef.current.play();
    }, [])

    return (
        <video ref={videoRef} width="100%" height="100%" muted loop >
            <source src={videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
        </video>
    )
}

const useStyles = makeStyles<Theme, any>((theme) => ({

}));

export default InteractiveSessions;